import clsx from 'clsx';
import React, { FC } from 'react';
import Checkbox from '../../../components/Checkbox/Checkbox';
import { useTranslate } from '../../../hooks/context/useTranslate';
import { ExportSection } from '../types';
import hasInvalidExportColumnOptions from '../utils/hasInvalidExportColumnOptions';

interface ExportSectionsSidebarProps {
  masterSection: ExportSection | undefined;
  subsetSections: ExportSection[];
  activeSection: ExportSection | undefined;
  onSelectSection: (section: ExportSection) => void;
  onToggleSection: (sectionId: string, enabled: boolean) => void;
}

const ExportSectionsSidebar: FC<ExportSectionsSidebarProps> = ({
  masterSection,
  subsetSections,
  activeSection,
  onSelectSection,
  onToggleSection,
}) => {
  const { t } = useTranslate();

  const handleSectionClick = (
    section: ExportSection,
    e: React.MouseEvent<HTMLDivElement>
  ): void => {
    if (section.enabled && (e.target as HTMLElement).closest('ion-checkbox'))
      return;
    onSelectSection(section);
  };

  return (
    <aside className="dataset-export-sidebar">
      <h2>{t('export.sections')}</h2>
      {masterSection && (
        <>
          <div className="dataset-export-section-group">
            {t('export.mainView')}
          </div>
          <div
            className={clsx(
              'dataset-export-section',
              masterSection.id === activeSection?.id && 'active',
              hasInvalidExportColumnOptions([masterSection]) && 'invalid'
            )}
            onClick={() => onSelectSection(masterSection)}
          >
            <Checkbox
              value={masterSection.enabled}
              onChange={(value) => onToggleSection(masterSection.id, value)}
              label={masterSection.label}
              disabled
              disableLabelClick
            />
          </div>
        </>
      )}

      {subsetSections.length > 0 && (
        <div className="dataset-export-section-group">
          {t('export.subordinateViews')}
        </div>
      )}
      {subsetSections.map((section) => (
        <div
          key={section.id}
          className={clsx(
            'dataset-export-section',
            section.id === activeSection?.id && 'active',
            hasInvalidExportColumnOptions([section]) && 'invalid'
          )}
          onClick={(e) => handleSectionClick(section, e)}
        >
          <Checkbox
            value={section.enabled}
            onChange={(value) => onToggleSection(section.id, value)}
            label={section.label}
            disableLabelClick
          />
        </div>
      ))}
    </aside>
  );
};

export default ExportSectionsSidebar;
